module.exports = __webpack_public_path__ + "img/arrow-select.svg";